module.exports = __webpack_public_path__ + "assets/asian-cb34a3.svg";